import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
BsShieldCheck,
BsDropletFill,
BsFire,
BsBug,
BsShieldExclamation,
BsFileEarmarkText
} from 'react-icons/bs';

import { useDashboard } from '../context/DashboardContext';

export default function ComplianceCentre() {
const navigate = useNavigate();
const { dashboardData, loading, errors } = useDashboard();

const cards = [
{
id: 1,
title: 'Food Safety',
percentage: '—',
status: 'No records',
statusColor: 'text-green-600',
icon: <BsShieldCheck className="text-xl text-green-600" />,
iconBg: 'bg-green-50'
},
{
id: 2,
title: 'Hygiene',
percentage: '—',
status: 'No records',
statusColor: 'text-green-600',
icon: <BsDropletFill className="text-xl text-blue-500" />,
iconBg: 'bg-blue-50'
},
{
id: 3,
title: 'Fire Safety',
percentage: '—',
status: 'No records',
statusColor: 'text-green-600',
icon: <BsFire className="text-xl text-red-500" />,
iconBg: 'bg-red-50'
},
{
id: 4,
title: 'Pest Control',
percentage: '—',
status: 'No records',
statusColor: 'text-green-600',
icon: <BsBug className="text-xl text-emerald-600" />,
iconBg: 'bg-emerald-50'
},
{
id: 5,
title: 'Allergen Management',
percentage: '—',
status: 'No records',
statusColor: 'text-green-600',
icon: <BsShieldExclamation className="text-xl text-blue-600" />,
iconBg: 'bg-blue-50'
},
{
id: 6,
title: 'Documents',
percentage: '—',
status: 'No records',
statusColor: 'text-green-600',
icon: <BsFileEarmarkText className="text-xl text-blue-500" />,
iconBg: 'bg-blue-50'
}
].map(card => ({ ...card, ...(dashboardData.complianceCentre?.find(area => area.title === card.title) || {}),
status: loading.complianceCentre ? 'Loading…' : errors.complianceCentre ? 'Unable to load' : dashboardData.complianceCentre?.find(area => area.title === card.title)?.status || 'No records' }));

const handleComplianceNavigation = () => {
navigate('/compliance-center');
};

return ( <div className="max-w-2xl w-full bg-white border border-slate-100 rounded-3xl p-6 shadow-sm font-sans text-slate-800">
  {/* HEADER SECTION */}
  <div className="flex items-center justify-between mb-5">
    <h2 className="text-lg font-bold text-slate-900">
      Compliance Centre
    </h2>

    <button
      type="button"
      onClick={handleComplianceNavigation}
      className="text-[#3a31d8] text-xs font-bold hover:underline"
    >
      View Compliance Centre
    </button>
  </div>

  {/* METRICS GRID */}
  <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-5">
    {cards.map((card) => (
      <div
        key={card.id}
        className="border border-slate-100 rounded-2xl p-4 flex items-center gap-4 bg-white shadow-[0_2px_8px_rgba(0,0,0,0.01)]"
      >
        {/* ICON */}
        <div className={`p-3 rounded-full shrink-0 ${card.iconBg}`}>
          {card.icon}
        </div>

        {/* CONTENT */}
        <div className="min-w-0">
          <h3 className="text-xs font-bold text-slate-700 truncate leading-tight">
            {card.title}
          </h3>

          <div className="text-xl font-extrabold text-slate-900 tracking-tight my-0.5">
            {card.percentage}
          </div>

          <p
            className={`text-[11px] font-bold ${card.statusColor} leading-none`}
          >
            {card.status}
          </p>
        </div>
      </div>
    ))}
  </div>

  {/* BOTTOM ACTION BUTTON */}
  <button
    type="button"
    onClick={handleComplianceNavigation}
    className="w-full bg-[#f4f3ff] hover:bg-[#e9e7ff] text-[#3a31d8] py-3 rounded-xl text-xs font-bold transition flex items-center justify-center gap-2 border border-transparent active:border-slate-200"
  >
    <BsFileEarmarkText className="text-base" />
    <span>View Full Compliance Report</span>
  </button>
</div>
);
}
